import { inject, Pipe, PipeTransform } from "@angular/core";
import { TranslocoService } from "@jsverse/transloco";

@Pipe({
    name: "displayResults",
    pure: false
})
export class DisplayResultsPipe implements PipeTransform {
    private readonly translocoService = inject(TranslocoService);

    public transform(resultsLength: number): string {
        if (resultsLength === 0) {
            return this.getMessage(resultsLength);
        }

        const message = this.getMessage(resultsLength);
        return `${resultsLength} ${message}`;
    }

    private getMessage(resultsLength: number): string {
        if (resultsLength === 0) {
            return this.translocoService.translate("supplier_search.no_results");
        }

        if (resultsLength === 1) {
            return this.translocoService.translate("supplier_search.result");
        }

        return this.translocoService.translate("supplier_search.results");
    }
}
